import { WebApiAdaptor } from "@syncfusion/ej2-data";

class CustomAdaptor extends WebApiAdaptor {
  processQuery(dm, query) {
    //console.log("Processing query:", query);
    return super.processQuery(dm, query);
  }

  beforeSend(dm, req, settings) {
    const token = localStorage.getItem("accessToken");
    if (token) {
      req.headers.set("Authorization", `Bearer ${token}`);
    }
    //console.log("Request before send:", req);
    return super.beforeSend(dm, req, settings);
  }

  processResponse(dm, response, ds, request) {
    // console.log("dm:", dm);
    // console.log("response:", response);
    // console.log("ds:", ds);
    // console.log("request:", request);
    return super.processResponse(dm, response, ds, request);
  }
}

export default CustomAdaptor;
